import { useQuery } from "react-query";
import { Menu } from "../models/Menu.model";
import { GUEST_USER, LOCATION_MENU_SERVICE, MENU_CACHE_VERSION_KEY } from "../constants";
import { reorderCategories } from "../helpers/helperMethods";
import axiosNoInterceptor from "../services/axiosNoInterceptor";
interface IPayload {
  location_id?: string;
  customer_id?: number | null | undefined;
}

interface IAuthInfo {
    userId: number;
    type: string | null
}

export const getCategories = async (location_id: string | null | undefined, user: IAuthInfo) => {
  const payload: IPayload = {}
  if ( location_id ) payload.location_id = location_id
  if ( user.type !== GUEST_USER ) payload.customer_id = user?.userId || null
  const response = await axiosNoInterceptor.get(`${LOCATION_MENU_SERVICE}/getLocationMenu`, { params: payload })
  let sortedCategories = reorderCategories(response.data.data.categories);
  return sortedCategories.filter(
    (category) => category.items && category.items.length > 0
  );
};

export default function useCategories(location_id: string | null | undefined, user: IAuthInfo) {
  let menuVersion = Number(localStorage.getItem(MENU_CACHE_VERSION_KEY)) || 0;
  return useQuery<Menu[]>(
    ["categories", location_id, menuVersion],
    () => getCategories(location_id, user),
    {
      staleTime: Infinity, 
      cacheTime: 1000 * 60 * 60,
    }
  );
}